<div *ngIf="showHeader" class="header-container">
    <global-message></global-message>
    <preheader></preheader>
    <div id="usanaShopHeader">
        <div class="shopHeader">
            <div class="shopHeader--nav top">
                <div class="shopHeader--navItem logo">
                    <a class="navLogo d-none d-md-block" [ngClass]="{'baoying-logo': showBaoying}" [routerLink]="homeLinkEnabled ? [LANDING_ROUTE] : null"
                       aria-label="USANA">
                        <img id="usanaLogoTagLine" src="{{logoUrl}}" alt="" aria-hidden="true">
                    </a>
                    <!--                    Mobile menu hamburger icon-->
                    <div class="iconBtn d-md-none " [attr.aria-label]="'cart.mobile.main.menu' | translate" (click)="setMobileNav()">
                        <i class="fa-solid fa-bars"></i>
                    </div>

                    <div class="usanaSearch" *ngIf="!limitedShopGroup">
                        <quick-search (selectedProduct)="searchItemSelected($event)" [warehouse]="currentWarehouse"
                                      resultLayout="header"></quick-search>
                    </div>
                    <!--                    Mobile menu logo img-->
                    <a class="mobile-header-logo d-md-none" [routerLink]="homeLinkEnabled ? [LANDING_ROUTE] : null"
                       aria-label="USANA">
                        <img src="{{mobileHeaderLogoUrl}}" alt="" aria-hidden="true">
                    </a>
                    <div class="text-right">
                        <span class="navLink sponsor d-none d-md-block" *ngIf="displaySponsorDetails">
                            <sup translate="cart.sponsor.title"></sup>
                            <a *ngIf="!!sponsorDetails.siteUrl" href="{{sponsorDetails.siteUrl}}">
                                <span>{{sponsorName | limitToWithEllipse: 15}}</span>
                            </a>
                            <span *ngIf="!sponsorDetails.siteUrl">{{sponsorName}}</span>
                        </span>
                            <span class="navLink emp" *ngIf="displayLoginButton">
                            <a href="javascript:void(0)" class="text-uppercase" (click)="login()"
                               translate="cart.login"></a>
                        </span>

                        <span class="navLink userDropDown d-none d-md-block" dropdown *ngIf="authenticated"
                              (click)="closeAllAlerts()">
                        <a href="javascript:void(0)" class="text-uppercase" dropdownToggle
                           id="menubutton" aria-controls="menu" [attr.data-automation]="'cart.user.dropdown'">
                            {{welcomeName}}
                            <i class="fa-solid fa-chevron-down"></i>
                        </a>
                        <ul *dropdownMenu role="menu" class="dropdown-menu" aria-labelledby="menubutton">
                            <li *ngIf="employee">
                                <a [routerLink]="ADMIN_ROUTE" class="dropdown-menu-top" role="menuitem">
                                    <span class="user-dropdown-option">Admin</span>
                                </a>
                            </li>
                             <li *ngIf="affiliate && !eventShopping">
                                <a [routerLink]="AFFILIATE_DASHBOARD_ROUTE"
                                   [attr.data-automation]="'cart.affiliate.dashboard'" role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.affiliate.dashboard"></span>
                                </a>
                            </li>
                            <li *ngIf="canEditAutoOrderOnline || canAddAutoOrderOnline">
                                <a [routerLink]="nfrMhpShoppingOnly ? [MHP_SELECT_ROUTE] : [AUTO_ORDER_MANAGE_ROUTE]"
                                   class="dropdown-menu-top" [attr.data-automation]="'cart.manage.ao'" role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.manage.ao"></span>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="ORDER_HISTORY_ROUTE" [attr.data-automation]="'cart.order.history'"
                                   role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.order.history"></span>
                                </a>
                            </li>
                            <li *ngIf="showReferralCreditProgram">
                                <a [routerLink]="[REFERRAL_CREDIT_ROUTE]" [queryParams]="{clear: true}"
                                   [attr.data-automation]="'cart.referral.credits'" role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.referral.credits"></span>
                                </a>
                            </li>
                            <li *ngIf="showFbShareables || showUrlShareables">
                                <a [routerLink]="SHARE_LIST_ROUTE" [attr.data-automation]="'cart.manage.share.lists'"
                                   role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.manage.share.lists"></span>
                                </a>
                            </li>
                            <ng-container *ngIf="preferredCustomer || affiliate">
                                <li>
                                    <a [href]="getPersonalInfoLink()" target="_blank"
                                       [attr.data-automation]="'cart.personal.information'" role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.personal.information"></span>
                                    </a>
                                </li>
                            </ng-container>
                            <ng-container *ngIf="affiliate">
                                <li>
                                    <a [href]="getTaxInfoLink()" target="_blank"
                                       [attr.data-automation]="'cart.tax.information'">
                                        <span class="user-dropdown-option" translate="cart.tax.information"></span>
                                    </a>
                                </li>
                            </ng-container>
                            <ng-container *ngIf="preferredCustomer || affiliate">
                                <li>
                                    <a [href]="getNotificationLink()" target="_blank"
                                       [attr.data-automation]="'cart.customer.notification'" role="menuitem">
                                        <span class="user-dropdown-option"
                                              translate="cart.customer.notification"></span>
                                    </a>
                                </li>
                            </ng-container>
                            <ng-container *ngIf="affiliate">
                                 <li>
                                    <a [href]="getAffiliateOrderHistoryLink()" target="_blank"
                                       [attr.data-automation]="'cart.customer.order.history'" role="menuitem">
                                        <span class="user-dropdown-option"
                                              translate="cart.customer.order.history"></span>
                                    </a>
                                </li>
                            </ng-container>
                            <ng-container *ngIf="preferredCustomer">
                                <li>
                                    <a [href]="getReturnsLink()" target="_blank"
                                       [attr.data-automation]="'cart.customer.returns'" role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.customer.returns"></span>
                                    </a>
                                </li>
                            </ng-container>
                                <li *ngIf="showNfrLink">
                                    <a [href]="getNfrLink()" target="_blank"
                                       [attr.data-automation]="'cart.customer.nfr'" role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.customer.nfr"></span>
                                    </a>
                                </li>
                                <li *ngIf="showGoToHub">
                                    <a [href]="getHubLink()" target="_blank" [attr.data-automation]="'cart.goto.hub'"
                                       role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.goto.hub"></span>
                                    </a>
                                </li>
                                <li *ngIf="chinaCustomer">
                                    <a (click)="goToContactCustomer()"
                                       [attr.data-automation]="'cart.contact.customer.service'" role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.contact.customer.service"></span>
                                    </a>
                                </li>
                                <li class="border-top">
                                    <a [routerLink]="LOGOUT_ROUTE" [attr.data-automation]="'cart.enroll.logout'"
                                       role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.enroll.logout"></span>
                                    </a>
                                </li>
                            </ul>
                        </span>
                        <span class="navLink d-none d-md-block" *ngIf="authenticated">
                            <ao-dropdown [(aoDropdownDisabled)]="aoDropdownDisabled"></ao-dropdown>
                        </span>
                        <span class="navLink d-none d-md-block" *ngIf="showCart">
                            <cart-icon></cart-icon>
                        </span>
                        <span class="navLink d-none d-md-block" *ngIf="displayLocaleSwitcherButton">
                            <a href="javascript:void(0)" (click)="openLocaleSwitcher()" class="btn btn-link locale">
                                <flag-icon [localeCountry]="userCountry"></flag-icon>
                                <span>{{userLanguage}}</span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <div class="shopHeader--nav bottom d-none d-md-block">
                <div class="navLink">
                <span dropdown automation-tag="menuDropDown" class="largeDropDownMenu" *ngIf="!limitedShopGroup">
                    <a href="javascript:void(0)" id="categories-nav-button" dropdownToggle
                       translate="cart.categories"></a>
                    <div class="shopCategories dropdown-menu" *dropdownMenu role="menu">
                        <!--Lifestyle tag category-->
                        <div class="category-dropdown">
                            <div class="flex-col nav-lifestyle" *ngIf="(lifestyles$ | async)?.length >0">
                                <h5 class="category-group-header" translate="cart.shop.by.lifestyle"></h5>
                                <ul class="category-link-list"
                                    *ngFor="let navItems of (lifestyles$ | async); trackBy: trackByFn">
                                     <li *ngFor="let navItem of navItems.children; trackBy: trackByFn">
                                         <a *ngIf="!!navItem.navDisplay" automation-tag="subMenuItemLink"
                                            [routerLink]="[TAG_CATALOG_ROUTE, navItem.id]" role="menuitem" [translate]="navItem.translationTag"></a>
                                    </li>
                                </ul>
                            </div>
                            <!-- Categories -->
                            <div class="flex-col nav-erp">
                                <h5 class="category-group-header" translate="cart.shop.by.category"></h5>
                                <div class="flex-category-wrapper">
                                    <div *ngFor="let navItem of nav$ | async; trackBy: trackByFn"
                                         class="category-link-group"
                                         automation-tag="menuItemLink">
                                        <a class="group-title" (click)="clearCategoryFilters()"
                                           [routerLink]="[CATALOG_ROUTE, navItem.id]" role="menuitem" [translate]="navItem.translationTag"></a>
                                        <ul class="category-link-list">
                                            <li *ngFor="let subNavItem of navItem.children; trackBy: trackByFn">
                                                <a automation-tag="subMenuItemLink" (click)="clearCategoryFilters()"
                                                   [routerLink]="[CATALOG_ROUTE, subNavItem.id]" role="menuitem" [translate]="subNavItem.translationTag"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- body benefits tag -->
                            <div class="flex-col nav-body-benefits"
                                 *ngIf="(bodyBenefits$ | async)?.length > 0">
                                <div *ngFor="let navItem of bodyBenefits$ | async; trackBy: trackByFn"
                                     class="navItemCol">
                                    <h5 class="category-group-header" translate="cart.shop.by.body.benefit"></h5>
                                    <div class="flex-category-wrapper" *ngIf="!!navItem.navDisplay">
                                        <ul class="category-link-list" *ngIf="!!navItem.navDisplay">
                                            <ng-container *ngFor="let subNavItem of navItem.children; trackBy: trackByFn">
                                                <li class="categoryLink nested" *ngIf="!!subNavItem.navDisplay" >
                                                    <a automation-tag="subMenuItemLink"
                                                       [routerLink]="[TAG_CATALOG_ROUTE, subNavItem.id]" role="menuitem" [translate]="subNavItem.translationTag"></a>
                                                </li>
                                                </ng-container>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="nav-shop-all">
                                  <a class="d-block" [routerLink]="[CATALOG_ROUTE, -1]"
                                     translate="cart.shop.all.products" role="menuitem"></a>
                            </div>
                        </div>
                    </div>
                </span>
                    <span class="categoryLink padding-lr-15" *ngIf="limitedShopping && authenticated">
                    <a (click)="clearCategoryFilters()" [routerLink]="[CATALOG_ROUTE, -1]"><span
                        translate="cart.shop.all.products"></span></a>
                </span>
                    <span class="categoryLink padding-lr-15" *ngIf="showBuildMhpLink">
                    <a [routerLink]="MHP_WHY_ROUTE"><span translate="cart.myhealthpak" alt=""></span></a>
                </span>
                    <span *ngIf="showClassicShopLink" class="categoryLink padding-lr-15">
                    <a href="/frame/shopSecureForward.jsp?url=shop" target="_blank">
                        <span translate="cart.classic.shop"></span>
                    </a>
                </span>
                </div>
            </div>
            <div class="shopHeader--nav nfr-banner" *ngIf="nfrShopping || nfrMhpShoppingOnly">
                <a href="javascript:void(0)" (click)="openExitNfrDialog()"><span
                    translate="cart.exit.nfr.banner"></span></a>
            </div>
            <div class="shopHeader--nav nfr-banner" *ngIf="employee">
                <a href="javascript:void(0)" (click)="toggleEmployeePriceType()"
                   [translate]="payingWithUsanaBucks ? 'cart.employee.switchpayment.personal' : 'cart.employee.switchpayment.usanabucks'"></a>
            </div>
            <div class="shopHeader--nav event-banner" *ngIf="eventShoppingEligible">
                <a href="javascript:void(0)" (click)="toggleEventShopping()"
                   [translate]="eventShopping ? 'cart.exit.event.shopping.banner' : 'cart.enter.event.shopping.banner'"></a>
            </div>
        </div>

        <!--side menu for mobile -->
        <div class="shopSideNav" [hidden]="!isSideMenuOpen">
            <!--Icon category selector EPR only markets-->
            <!--Icon category selector EPR only markets-->
            <div class="shopSideNav-header">
                <a class="navLogoText" (click)="isSideMenuOpen=false"
                   [routerLink]="homeLinkEnabled ? [LANDING_ROUTE] : null" aria-label="USANA">
                    <img id="usanaLogoText" src="{{mobileSideMenuLogoUrl}}" alt="" aria-hidden="true">
                </a>
                <button type="button" class="close fa-solid fa-xmark pull-right" [attr.aria-label]="'cart.button.close'| translate" (click)="isSideMenuOpen=false">
                </button>
            </div>

            <side-nav-account-switcher [sponsorName]="sponsorName" [displaySponsorDetails]="displaySponsorDetails"
                                       (closeSideMenu)="isSideMenuOpen=false"></side-nav-account-switcher>

            <div class="category-icon-group" *ngIf="sideNavShowIconCategories && !limitedShopGroup">
                <div class="category-icon-heading">
                    <h3 class="heading-3" translate="cart.shop.by.category"></h3>
                    <a translate="cart.shop.all.category" (click)="isSideMenuOpen=false; clearCategoryFilters()"
                       [routerLink]="[CATALOG_ROUTE, null]"></a>
                </div>
                <nav-category [horizontalWrap]="true" [displaySize]="'sm'"
                              (closeSideMenu)="isSideMenuOpen=false"></nav-category>
            </div>
            <accordion [closeOthers]="true" class="shopSideNav-body" *ngIf="!sideNavShowIconCategories">

                <!--Top-->
                <!--Lifestyle Tag-->
                <accordion-group id="lifestylePanel" *ngIf="!limitedShopGroup && (lifestyles$ | async)?.length > 0"
                                 [(isOpen)]="mobileMenuCategories.isLifestyleOpen">
                    <div accordion-heading>
                        <span translate="cart.shop.by.lifestyle"></span>
                        <i class="sidenav-chevron fa"
                           [ngClass]="{'fa-angle-down': mobileMenuCategories.isLifestyleOpen, 'fa-angle-right': !mobileMenuCategories.isLifestyleOpen}"></i>
                    </div>
                    <div>
                        <ul class="category-link-list">
                            <ng-container *ngFor="let navItem of (lifestyles$ | async)[0].children; trackBy: trackByFn">
                                <li class="categoryLink nested" *ngIf="!!navItem.navDisplay">
                                    <a automation-tag="menuItemLink"
                                       (click)="isSideMenuOpen=false"
                                       [routerLink]="[TAG_CATALOG_ROUTE, navItem.id]" [translate]="navItem.translationTag"></a>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </accordion-group>
                <!--Categories-->
                <accordion-group id="categoryPanel" *ngIf="!limitedShopGroup"
                                 [(isOpen)]="mobileMenuCategories.isCategoriesOpen">
                    <div accordion-heading>
                        <span translate="cart.shop.by.category"></span>
                        <i class="sidenav-chevron fa"
                           [ngClass]="{'fa-angle-down': mobileMenuCategories.isCategoriesOpen, 'fa-angle-right': !mobileMenuCategories.isCategoriesOpen}"></i>
                    </div>
                    <div>
                        <ul class="category-link-list">
                            <li class="categoryLink nested" *ngFor="let navItem of nav$ | async; trackBy: trackByFn">
                                <a automation-tag="menuItemLink" (click)="isSideMenuOpen=false; clearCategoryFilters()"
                                   [routerLink]="[CATALOG_ROUTE, navItem.id]" [translate]="navItem.translationTag"></a>
                            </li>
                        </ul>
                    </div>
                </accordion-group>
                <!--Body Benefits-->
                <accordion-group id="bodyBenefitPanel" *ngIf="!limitedShopGroup && (bodyBenefits$ | async)?.length > 0"
                                 [(isOpen)]="mobileMenuCategories.isBodyBenefitsOpen">
                    <div accordion-heading>
                        <span translate="cart.shop.by.body.benefits"></span>
                        <i class="sidenav-chevron fa"
                           [ngClass]="{'fa-angle-down': mobileMenuCategories.isBodyBenefitsOpen, 'fa-angle-right': !mobileMenuCategories.isBodyBenefitsOpen}"></i>
                    </div>
                    <div>
                        <ul class="category-link-list">
                            <ng-container  *ngFor="let navItem of (bodyBenefits$ | async)[0].children; trackBy: trackByFn">
                                <li class="categoryLink nested" *ngIf="!!navItem.navDisplay">
                                    <a  automation-tag="menuItemLink"
                                       (click)="isSideMenuOpen=false"
                                       [routerLink]="[TAG_CATALOG_ROUTE, navItem.id]" [translate]="navItem.translationTag"></a>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </accordion-group>
                <accordion-group *ngIf="!limitedShopGroup && showAllProductsLink()">
                    <div accordion-heading class="categoryLink">
                        <a (click)="isSideMenuOpen=false; clearCategoryFilters()" [routerLink]="[CATALOG_ROUTE, null]">
                            <span translate="cart.shop.all.products"></span>
                        </a>
                    </div>
                </accordion-group>
                <accordion-group *ngIf="showBuildMhpLink">
                    <div accordion-heading class="categoryLink">
                        <a (click)="isSideMenuOpen=false" [routerLink]="MHP_WHY_ROUTE"><span
                            translate="cart.myhealthpak"></span></a>
                    </div>
                </accordion-group>
                <accordion-group *ngIf="showClassicShopLink">
                    <div accordion-heading class="categoryLink">
                        <a href="/frame/shopSecureForward.jsp?url=shop" target="_blank"
                           analytics-on
                           analytics-event="classic-shop-exit"
                           analytics-category="mobile-nav"
                           analytics-label="classic-shop-exit-mobile"
                           analytics-value="classic-shop-exit-mobile"><span translate="cart.classic.shop"></span>
                        </a>
                    </div>
                </accordion-group>
            </accordion>
            <hr>
            <!--bottom-->
            <div class="shopSideNav-bottom">
                <div class="bottom-item" *ngIf="affiliate && !eventShopping">
                    <a (click)="isSideMenuOpen=false" [routerLink]="AFFILIATE_DASHBOARD_ROUTE"
                       [attr.data-automation]="'mobile.cart.affiliate.dashboard'">
                        <span translate="cart.affiliate.dashboard"></span> <span
                        class="status-badge status-blue margin-left-8" translate="cart.status.badge.new"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="canEditAutoOrderOnline || canAddAutoOrderOnline">
                    <a (click)="isSideMenuOpen=false"
                       [routerLink]="nfrMhpShoppingOnly ? [MHP_SELECT_ROUTE] : [AUTO_ORDER_MANAGE_ROUTE]"
                       [attr.data-automation]="'mobile.cart.manage.ao'">
                        <span translate="cart.manage.ao"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="authenticated">
                    <a (click)="isSideMenuOpen=false" [routerLink]="ORDER_HISTORY_ROUTE"
                       [attr.data-automation]="'mobile.cart.order.history'">
                        <span translate="cart.order.history"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="showReferralCreditProgram">
                    <a (click)="isSideMenuOpen=false" [routerLink]="[REFERRAL_CREDIT_ROUTE]"
                       [queryParams]="{clear: true}" [attr.data-automation]="'mobile.cart.referral.credits'">
                        <span translate="cart.referral.credits"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="(showFbShareables || showUrlShareables) && authenticated">
                    <a (click)="isSideMenuOpen=false" [routerLink]="SHARE_LIST_ROUTE"
                       [attr.data-automation]="'mobile.cart.manage.share.lists'">
                        <span translate="cart.manage.share.lists"></span>
                    </a>
                </div>
                <ng-container *ngIf="preferredCustomer || affiliate">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getPersonalInfoLink())" href="javascript:void(0)"
                           [attr.data-automation]="'mobile.cart.personal.information'">
                            <span translate="cart.personal.information"></span>
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="affiliate">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getTaxInfoLink())" href="javascript:void(0)"
                           [attr.data-automation]="'mobile.cart.tax.information'">
                            <span translate="cart.tax.information"></span>
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="preferredCustomer || affiliate">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getNotificationLink())" href="javascript:void(0)"
                           [attr.data-automation]="'mobile.cart.customer.notification'">
                            <span translate="cart.customer.notification"></span>
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="affiliate">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getAffiliateOrderHistoryLink())" href="javascript:void(0)"
                           [attr.data-automation]="'mobile.cart.customer.order.history'">
                            <span translate="cart.customer.order.history"></span>
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="preferredCustomer">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getReturnsLink())" href="javascript:void(0)"
                           [attr.data-automation]="'mobile.cart.customer.returns'">
                            <span translate="cart.customer.returns"></span>
                        </a>
                    </div>
                </ng-container>

                <div class="bottom-item" *ngIf="showGoToHub">
                    <a (click)="mobileNavigateTo(getHubLink())" href="javascript:void(0)"
                       [attr.data-automation]="'mobile.cart.goto.hub'">
                        <span translate="cart.goto.hub"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="chinaCustomer">
                    <a (click)="isSideMenuOpen=false; goToContactCustomer()"
                       [attr.data-automation]="'mobile.cart.contact.customer.service'">
                        <span translate="cart.contact.customer.service"></span>
                    </a>
                </div>
                <div class="bottom-item border-top" *ngIf="authenticated">
                    <a (click)="isSideMenuOpen=false" [routerLink]="LOGOUT_ROUTE"
                       [attr.data-automation]="'cart.enroll.logout'">
                        <span translate="cart.enroll.logout"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="displayLocaleSwitcherButton">
                    <a (click)="openLocaleSwitcher()">
                        <flag-icon [localeCountry]="userCountry"></flag-icon>
                        <span>{{userLanguage}}</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="shopSideNav-overlay" [hidden]="!isSideMenuOpen" (click)="isSideMenuOpen=false"></div>
    </div>
    <account-switcher></account-switcher>
</div>
